
    import PageHeader from '../components/Layout/PageHeader.vue';
    
    export default {
    data() {
        return {
            news: [],
            current_page: 1,
            selected_category: "",
            order: "desc",
            loading: true
        };
    },
    created() {
        this.fetchNews();
    },
    mounted() {
        // console.log('Component mounted.')
    },
    methods: {
        async fetchNews() {
            this.loading = true;
            const result = await this.$axios.get(`/news?page=${this.current_page}&results=12&category=${this.selected_category}&order=${this.order}`);
            this.news = result.data.results;
            this.loading = false;
            // .then((response) => {
            //     // this.news = response.data.data.slice(0, 5);
            //     this.news = response.data.results;
            //     this.loading = false;
            // })
            // .catch(error => {
            //     // console.error("There was an error!", error);
            // });
        }
    },
    components: { PageHeader }
}
